import React, { useState } from "react";
import NotificationToast from "../Component/Toast";
import { get_login_code } from "../apis/GetLoginCodeAPI";
import { login } from "../apis/LoginAPI";
import Cookies from "js-cookie";
import "../css/LiquidDropLogin.css";
import { useNavigate } from "react-router-dom";
import SelectOptionTop from "./SelectOptionTop";
import { useTranslation } from "../contexts/LocaleContext";

const LiquidDropLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isGettingCode, setIsGettingCode] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const navigate = useNavigate();
  const { locale, setLocale, t } = useTranslation();
  // language selection will use SelectOption component

  const showToast = (message) => {
    setToastMessage(message);
    setTimeout(() => setToastMessage(""), 3000);
  };

  // (verification code flow removed for this simplified layout)
  // verification code flow: request code and start countdown
  const handleGetCode = async () => {
    if (!username.trim()) {
      showToast(t("login.enter_username", "Please enter your username"));
      return;
    }
    if (countdown > 0 || isGettingCode) return;
    setIsGettingCode(true);
    try {
      const res = await get_login_code(username);
      if (res && res.data && res.data.code === 200) {
        showToast(t("login.code_sent", "Verification code has been sent"));
        setCountdown(60);
      } else {
        showToast(
          (res && res.data && res.data.message) ||
            t("login.code_failed", "Failed to get verification code")
        );
      }
    } catch (err) {
      console.error(err);
      showToast(t("login.code_failed", "Failed to get verification code"));
    } finally {
      setIsGettingCode(false);
    }
  };

  // countdown effect
  React.useEffect(() => {
    if (countdown <= 0) return;
    const id = setInterval(() => {
      setCountdown((c) => {
        if (c <= 1) {
          clearInterval(id);
          return 0;
        }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(id);
  }, [countdown]);
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username.trim()) {
      showToast(t("login.enter_username", "Please enter your username"));
      return;
    }
    if (!password.trim()) {
      showToast(t("login.enter_password", "Please enter your password"));
      return;
    }
    // code is optional in this layout (not required)
    setIsLoggingIn(true);
    try {
      const response = await login(username, password, code);
      if (response && response.data && response.data.code === 200) {
        const token = response.data.data;
        const userid = response.data.userid;
        const usertype = response.data.usertype;
        const usernameRes = response.data.userName;
        showToast(t("login.success", "Login successful"));
        Cookies.set("token", token);
        Cookies.set("userid", userid);
        Cookies.set("usertype", usertype);
        Cookies.set("username", usernameRes);
        navigate("/Home");
      } else {
        showToast(t("login.failed", "Login failed. Please try again"));
      }
    } catch (err) {
      console.error(err);
      showToast(t("login.failed", "Login failed. Please try again"));
    } finally {
      setIsLoggingIn(false);
    }
  };

  return (
    <>
      <div className="auth-layout">
        <div className="auth-left">
          <div className="auth-left-inner">
            <div className="illustration">
              <img alt="illustration" src="/head/login.png" />
            </div>
          </div>
        </div>

        <div className="auth-right">
          <div className="auth-card" role="form" aria-label="Login">
            <div className="auth-top"> 

              <div className="auth-title">{t("login.title", "Login")}</div>
              <div className="lang-select">
                <SelectOptionTop
                  value={locale}
                  onChange={(v) => setLocale(v)}
                  options={[
                    { value: "zh", label: t("lang.chinese", "中文") },
                    { value: "en", label: t("lang.english", "EN") },
                  ]}
                  ariaLabel="Language"
                />
              </div>
            </div>

            <form className="auth-form" onSubmit={handleLogin}>
              <div className="input-dark">
                <input
                  type="text"
                  placeholder={t("login.username", "用户名")}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>

              <div className="input-dark input-with-icon">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder={t("login.password", "密码")}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="eye-btn"
                  onClick={() => setShowPassword((s) => !s)}
                  aria-label="Toggle password visibility"
                >
                  {showPassword ? (
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      aria-hidden="true"
                    >
                      <path
                        d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"
                        fill="none"
                        stroke="#9ca3af"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M17.94 17.94L6.06 6.06"
                        fill="none"
                        stroke="#9ca3af"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M14.12 14.12A3 3 0 0 1 9.88 9.88"
                        fill="none"
                        stroke="#9ca3af"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      aria-hidden="true"
                    >
                      <path
                        d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"
                        fill="none"
                        stroke="#9ca3af"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <circle cx="12" cy="12" r="3" fill="#9ca3af" />
                    </svg>
                  )}
                </button>
              </div>

              <div className="code-row">
                <div className="input-dark" style={{ flex: 1 }}>
                  <input
                    type="text"
                    placeholder={t("login.code", "Code")}
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                  />
                </div>
                <button
                  type="button"
                  className="get-code-btn"
                  onClick={handleGetCode}
                  disabled={isGettingCode || countdown > 0}
                >
                  {isGettingCode ? (
                    <span className="btn-spinner-inline" aria-hidden="true" />
                  ) : countdown > 0 ? (
                    `${countdown}s`
                  ) : (
                    t("login.get_code", "Get Code")
                  )}
                </button>
              </div>

              <button
                type="submit"
                className="btn-primary auth-submit"
                disabled={isLoggingIn}
              >
                {isLoggingIn
                  ? t("login.loading", "加载中...")
                  : t("login.login", "登录")}
              </button>
            </form>
          </div>
        </div>
      </div>
      <NotificationToast
        message={toastMessage}
        type="success"
        onClose={() => setToastMessage("")}
      />
    </>
  );
};

export default LiquidDropLogin;
